// src/lib/cache/expenses.js
//
// Per-entity cache wiring for expenses. listExpenses resolves its own
// companyId via getValidatedCompanyId, so the fetcher ignores the
// companyId arg passed by unwrapList.

import {
  listExpenses,
  createExpense,
  updateExpense,
  deleteExpense,
} from '../api/financial/expenses.js'
import {
  useEntityListQuery,
  useOptimisticListMutation,
  useStandardDeleteMutation,
  defaultCreateReconcile,
  defaultUpdateReconcile,
  unwrapList,
} from './entityCache.js'

const ENTITY = 'expenses'

const buildCreatePlaceholder = (vars, tempId) => {
  const now = new Date().toISOString()
  return {
    status: 'recorded',
    ...vars,
    id: tempId,
    created_at: now,
    updated_at: now,
  }
}

export const useExpensesQuery = () =>
  useEntityListQuery(ENTITY, unwrapList('expenses', () => listExpenses()))

export const useCreateExpenseMutation = () =>
  useOptimisticListMutation(ENTITY, {
    mutationFn: (expenseData) => createExpense(expenseData),
    applyOptimistic: (prev, vars, { tempId }) => [
      buildCreatePlaceholder(vars, tempId),
      ...prev,
    ],
    reconcile: defaultCreateReconcile,
  })

export const useUpdateExpenseMutation = () =>
  useOptimisticListMutation(ENTITY, {
    mutationFn: ({ id, ...patch }) => updateExpense(id, patch),
    applyOptimistic: (prev, vars) =>
      prev.map((row) => (row.id === vars.id ? { ...row, ...vars } : row)),
    reconcile: defaultUpdateReconcile,
  })

export const useDeleteExpenseMutation = () =>
  useStandardDeleteMutation(ENTITY, deleteExpense)
